import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {assignIn} from 'lodash';
import * as moment from 'moment';
import {AppConfigsService, AuthService} from '@ft/core';

@Component({
    selector: 'app-cancellation',
    templateUrl: './cancellation.component.html',
    styleUrls: ['./cancellation.component.scss']
})
export class CancellationDialogComponent implements OnInit {
    subscription: Subscription;

    model = {cancellation_date: moment().format('YYYY-MM-DD'), reason: null};

    constructor(public dialogRef: MatDialogRef<CancellationDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any, public appConfigService: AppConfigsService, public authService: AuthService) {
    }

    ngOnInit(): void {
    }


    handleSave() {
        this.dialogRef.close(assignIn(this.model, {cancelled: true},
            !this.authService.isRoot() ? {cancelled_by: this.authService.getStaff()} : {}));
    }
}
